import { midfieldDefaults } from '../defaults';
import { getGamesByGamePks } from '../queries/getGamesByGamePks';

const { supportedLocales, contentSource } = midfieldDefaults;

const getContentGraphParams = ({ locale, gamePk, gameContext = 'mlb', env = 'prod' }) => {
    const variables = {
        gameRecapTags: ['game-recap'],
        relatedArticleTags: ['storytype-article'],
        gamePks: [gamePk],
        locale: supportedLocales.get(locale) || 'EN_US',
        contentSource: contentSource[gameContext] || contentSource.mlb
    };

    return {
        env,
        variables: encodeURIComponent(JSON.stringify(variables)),
        query: encodeURIComponent(getGamesByGamePks)
    };
};

export default getContentGraphParams;
